export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  WHATSAPP_EMBEDDED_SIGNUP_FLOW: 'whatsapp_embedded_signup_inbox_creation',
  WHATSAPP_MANUAL_TRANSFER: 'whatsapp_manual_transfer',
  WHATSAPP_RECONFIGURE: 'whatsapp_reconfigure',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  DATA_IMPORT: 'data_import',
  API_AND_WEBHOOKS: 'api_and_webhooks',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  MENTIONS: 'mentions',
  PARTICIPATING: 'participating',
  UNATTENDED: 'unattended',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CUSTOM_ROLES: 'custom_roles',
  JABVOX_V4: 'jabvox_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  CONTACT_JABVOX_SUPPORT_TEAM: 'contact_jabvox_support_team',
  SAML: 'saml',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  JABVOX_KANBAN: 'jabvox_kanban',
  JABVOX_PRODUCTS: 'jabvox_products',
  JABVOX_VOIP: 'jabvox_voip',
  JABVOX_SALDO: 'jabvox_saldo',
  JABVOX_SMS: 'jabvox_sms',
  JABVOX_AI_CHAT: 'jabvox_ai_chat',
  JABVOX_AI_CHAT_PROVISIONING: 'jabvox_ai_chat_provisioning',
  JABVOX_MANAGEMENT_STATES: 'jabvox_management_states',
  JABVOX_DIALER: 'jabvox_dialer',
  JABVOX_AFFILIATES: 'jabvox_affiliates',
  JABVOX_CALENDAR: 'jabvox_calendar',
  JABVOX_INTERNAL_CHAT: 'jabvox_internal_chat',
  JABVOX_RESPONSE_BOT: 'jabvox_response_bot',
  JABVOX_EMAIL: 'jabvox_email',
  JABVOX_FORMS: 'jabvox_forms',
  JABVOX_CDR: 'jabvox_cdr',
  JABVOX_WHATSAPP_TEMPLATES: 'jabvox_whatsapp_templates',
  JABVOX_WHATSAPP_FLOWS: 'jabvox_whatsapp_flows',
  JABVOX_AUDIO_ANALYSIS: 'jabvox_audio_analysis',
  JABVOX_CUSTOMIZATION: 'jabvox_customization',
  JABVOX_CLICK_TO_CALL: 'jabvox_click_to_call',
  JABVOX_SOFTPHONE: 'jabvox_softphone',
  JABVOX_ANALYTICS: 'jabvox_analytics',
  JABVOX_TASKS: 'jabvox_tasks',
  JABVOX_BULK_WHATSAPP: 'jabvox_bulk_whatsapp',
  JABVOX_WHATSAPP_GROUPS: 'jabvox_whatsapp_groups',
  JABVOX_VOICE_BROADCAST: 'jabvox_voice_broadcast',
  JABVOX_TICKETS: 'jabvox_tickets',
  JABVOX_LEAD_IMPORT: 'jabvox_lead_import',
  JABVOX_DATA_EXPORT: 'jabvox_data_export',
  JABVOX_LEAD_DELETE: 'jabvox_lead_delete',
  JABVOX_ADVANCED_AUTOMATIONS: 'jabvox_advanced_automations',
  // TODO(human decision): no account currently has this flag enabled - there
  // is no migration/admin UI wiring it up yet (out of scope for this PR, see
  // the other jabvox_* flags without a config/features.yml entry for
  // precedent). An account needs this flag explicitly enabled before the
  // Clinica route/sidebar entry becomes visible to it.
  JABVOX_CLINICA: 'jabvox_clinica',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  UNREAD_COUNT_FOR_FILTERS: 'unread_count_for_filters',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.JABVOX_AI_CHAT,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
];
